import React, { Component, Fragment } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { errorToast } from 'Common/ToastHelper';
import { SelectField } from 'Common/SemanticWrapper';
import { Filter, Main } from 'Containers';
import { NotificationDialog } from 'Components';
import { resetForm } from 'State/forms/actions';
import { ORDER_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  FilterEnum,
  BidGroupEnum,
  OrderFormReportEnum,
} from 'Common/FieldEnum';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import {
  GenericEnum,
  ReportTypeEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
  getStorageLocationForCurrentSite,
  clearFilterErrorMsg,
} from 'State/filters/actions';
import * as FilterSelectors from 'State/filters/selectors';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';

import * as CommonPrintSelector from './../../commonState/selectors';
import {
  printReportData,
  clearPrintReportError,
} from './../../commonState/actions';
import OrderFormReportComponent from '../components/OrderFormReport';

class OrderFormReportContainer extends Component {
  static propTypes = {
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    getStorageLocationForCurrentSite: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    clearFilterErrorMsg: PropTypes.func.isRequired,
    printLoading: PropTypes.bool.isRequired,
    fetchingDropdown: PropTypes.bool.isRequired,
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    assignItemsAcctCategoryData: PropTypes.array.isRequired,
    assignItemsVendorData: PropTypes.array.isRequired,
    assignItemStorageLocationData: PropTypes.array.isRequired,
    initialValues: PropTypes.object.isRequired,
    printData: PropTypes.string,
    sortOptionsValue: PropTypes.number,
    printError: PropTypes.object,
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    acctCategoryDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    storageLocationDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    printError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    acctCategoryDataError: null,
    vendorDataError: null,
    storageLocationDataError: null,
    printData: null,
    sortOptionsValue: PrintSortTypeEnum.ItemCode,
  };

  reactTableRef = React.createRef();
  state = {
    showPrintMsg: false,
    selectedSortOption: PrintSortTypeEnum.ItemCode,
    filterValues: {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
      [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Location]: GenericEnum.InitialFilterValue,
    },
    selectedSites: [],
    activeIndexForFilter: 0,
    allSites: [],
  };

  componentDidMount() {
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAcctCategoryForCurrentSite,
      getVendorForCurrentSite,
      getStorageLocationForCurrentSite,
    } = this.props;
    getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    getItemGroupForCurrentSite();
    getAcctCategoryForCurrentSite();
    getVendorForCurrentSite();
    getStorageLocationForCurrentSite();
  }

  componentDidUpdate(prevProps) {
    const {
      clearPrintReportError,
      clearFilterErrorMsg,
      printData,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'storageLocationDataError')
    ) {
      clearPrintReportError();
      clearFilterErrorMsg();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Order Form Report');
      clearPrintReportError();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.printReport,
            disabled: printLoading,
            loading: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  printReport = () => {
    const {
      selectedSites,
      allSites,
      selectedSortOption,
      filterValues: {
        GroupId_Bid,
        GroupId_Item,
        GroupId_Cat,
        VendorId,
        GroupId_Location,
      },
      bidPriceDate,
    } = this.state;
    const gridSortedData =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: allSites };
    let sites = [];
    _.forEach(gridSortedData.sortedData, obj => {
      if (obj._subRows) {
        const subRowSites = _.filter(
          obj._subRows,
          subObj => selectedSites.indexOf(subObj.Id) !== -1
        ).map(v => v.Id);
        sites = [...sites, ...subRowSites];
      } else {
        const id = obj.Id ? obj.Id : obj._original.Id;
        if (selectedSites.indexOf(id) !== -1) {
          sites.push(id);
        }
      }
    });
    if (sites.length) {
      const filtersOptions = {
        ReportType: ReportTypeEnum.OrderReport,
        SortBy: selectedSortOption,
        BidGroup: GroupId_Bid,
        ItemGroup: GroupId_Item,
        AccountCategory: GroupId_Cat,
        VendorId,
        GroupId_Location,
        BidPriceDT: moment(bidPriceDate).format(DATE_FORMAT_FOR_SERVER),
        SiteIds: sites,
      };
      this.props.printReportData(
        'PrintInventory/GetOrderOrPhysicalFormPrint',
        filtersOptions
      );
    } else {
      this.setState({
        showPrintMsg: true,
      });
    }
  };

  setSelectedSites = selectedSites => {
    this.setState({ selectedSites: selectedSites });
  };

  handlePrintMsgDialog = () => {
    this.setState({
      showPrintMsg: false,
    });
  };

  setSortByOption = value => {
    this.setState({
      selectedSortOption: value,
    });
  };

  handleChange = (e, values) => {
    this.setState({ filterValues: values });
  };

  clearFilters = () => {
    this.setState({
      filtered: [],
      filterValues: {
        [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
        [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
        [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
        [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
        [FilterEnum.GroupId_Location]: GenericEnum.InitialFilterValue,
      },
    });
    this.props.resetForm(ORDER_REPORT_FORM_NAME);
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  getSitesCallback = allSites => {
    this.setState({ allSites });
  };

  render() {
    const {
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      assignItemsAcctCategoryData,
      assignItemsVendorData,
      sortOptionsValue,
      fetchingDropdown,
      assignItemStorageLocationData,
    } = this.props;

    const fields = [
      {
        name: FilterEnum.GroupId_Bid,
        component: SelectField,
        type: 'text',
        options: assignItemsBidGroupData,
        label: 'BID GROUP',
        maxLength: 20,
        loading: fetchingDropdown,
      },
      {
        name: FilterEnum.GroupId_Item,
        component: SelectField,
        type: 'text',
        options: assignItemsItemGroupData,
        label: 'ITEM GROUP',
        loading: fetchingDropdown,
      },
      {
        name: FilterEnum.GroupId_Cat,
        component: SelectField,
        type: 'text',
        options: assignItemsAcctCategoryData,
        label: 'ACCT. CATEGORY',
        loading: fetchingDropdown,
      },
      {
        name: FilterEnum.VendorId,
        component: SelectField,
        type: 'text',
        options: assignItemsVendorData,
        label: 'DISTRIBUTOR',
        loading: fetchingDropdown,
      },
      {
        name: FilterEnum.GroupId_Location,
        component: SelectField,
        type: 'text',
        options: assignItemStorageLocationData,
        label: 'STORAGE LOCATION',
        loading: fetchingDropdown,
      },
    ];

    return (
      <Fragment>
        <Filter title={'Reports | Orders Form'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <OrderFormReportComponent
            fields={fields}
            handleChange={this.handleChange}
            filterValues={this.state.filterValues}
            clearFilters={this.clearFilters}
            sortOptionsValue={sortOptionsValue}
            setSortByOption={this.setSortByOption}
            setSelectedSites={this.setSelectedSites}
            activeIndexForFilter={this.state.activeIndexForFilter}
            handleClick={this.handleClick}
            reactTableRef={this.reactTableRef}
          />
          <NotificationDialog
            title={'Orders Report'}
            showDialog={this.state.showPrintMsg}
            message={'You must select at least 1 site.'}
            onOkClick={this.handlePrintMsgDialog}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(ORDER_REPORT_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(ORDER_REPORT_FORM_NAME)(state));

  return {
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
    fetchingDropdown:
      FilterSelectors.getBidGroupDataLoading(state) ||
      FilterSelectors.getItemGroupDataLoading(state) ||
      FilterSelectors.getAcctCategoryDataLoading(state) ||
      FilterSelectors.getStorageLocationDataLoading(state) ||
      FilterSelectors.getVendorDataLoading(state),
    assignItemsBidGroupData: FilterSelectors.selectBidGroupData(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    assignItemsAcctCategoryData: FilterSelectors.selectAcctCategoryData(state),
    assignItemsVendorData: FilterSelectors.selectVendorData(state),
    assignItemStorageLocationData: FilterSelectors.selectStorageLocationData(
      state
    ),
    initialValues: {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
      [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Location]: GenericEnum.InitialFilterValue,
      SortOptions: PrintSortTypeEnum.ItemCode,
    },
    sortOptionsValue: selector(state, OrderFormReportEnum.SortOptions),

    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    acctCategoryDataError: FilterSelectors.getAcctCategoryDataError(state),
    vendorDataError: FilterSelectors.getVendorDataError(state),
    storageLocationDataError: FilterSelectors.getStorageLocationDataError(
      state
    ),
  };
};

const mapDispatchToProps = {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getVendorForCurrentSite,
  getStorageLocationForCurrentSite,
  resetForm,
  printReportData,
  clearPrintReportError,
  clearFilterErrorMsg,
};

OrderFormReportContainer = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: ORDER_REPORT_FORM_NAME,
})(OrderFormReportContainer);

export const OrderFormReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderFormReportContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/orderformreport/containers/OrderFormReport.js